import { useRef, useState } from "react";
import { useLanguage } from "../i18n/LanguageProvider";
import { markBiometricOfferAfterLogin } from "../services/biometricAuth";
import {
  getAppleAuthErrorTranslationKey,
  isAppleAuthCancellation,
  isNativeIosAppleAuthAvailable,
  signInWithNativeApple,
} from "../services/appleAuth";

export default function AppleSignInButton({ onError }) {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const clickLockedRef = useRef(false);

  if (!isNativeIosAppleAuthAvailable()) return null;

  const handleAppleSignIn = async () => {
    if (clickLockedRef.current) return;
    clickLockedRef.current = true;
    setLoading(true);
    onError?.("");

    try {
      const credential = await signInWithNativeApple();
      markBiometricOfferAfterLogin(credential?.user?.uid);
    } catch (error) {
      if (!isAppleAuthCancellation(error)) {
        onError?.(t(getAppleAuthErrorTranslationKey(error)));
      }
    } finally {
      clickLockedRef.current = false;
      setLoading(false);
    }
  };

  return (
    <div className="vq-apple-auth-option">
      <div className="vq-apple-auth-separator" aria-hidden="true">
        <span />
        <b>{t("login.apple.or")}</b>
        <span />
      </div>
      <button
        className="vq-apple-auth-button"
        type="button"
        onClick={handleAppleSignIn}
        disabled={loading}
        aria-busy={loading}
      >
        <span className="vq-apple-auth-mark" aria-hidden="true"></span>
        <span>{loading ? t("login.apple.loading") : t("login.apple.button")}</span>
      </button>
    </div>
  );
}
